import React, { useEffect, useState, useCallback, useRef } from "react";
import Select from "react-select";
import axios from "axios";

const PopupComponent = (props) => {
  const [showButtons, setShowButtons] = useState(true);
  const [rowCount, setRowCount] = useState(1);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState("");
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");
  const [machineID, setMachineID] = useState("");
  const [status, setStatus] = useState("");
  const [machinenamedata, setMachinenamedata] = useState([]);
  const [Servicerequestformdata, setContactnamedata] = useState({});
  const [isVisible, setIsVisible] = useState("Web");
  const [formData, setFormData] = useState([
    { partNo: "", qty: "", description: "" },
  ]);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [origin, setOrigin] = useState("");
  const [submittedMessage, setSubmittedMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [partNumbersList, setPartNumbersList] = useState([]);
  const [openPartDropdownIndex, setOpenPartDropdownIndex] = useState(null);
  const partDropdownWrapperRefs = useRef([]);

  const email = sessionStorage.getItem("email");

  const [errors, setErrors] = useState({
    partNo: [],
    qty: [],
    description: [],
  });
  const [formError, setFormError] = useState("");

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      partNo: [],
      qty: [],
      description: [],
    };

    // Check if all required fields are filled
    const missingFields = [];
    if (!selectedMachine) {
      isValid = false;
      missingFields.push("Machine Name");
    }

    if (!type) {
      isValid = false;
      missingFields.push("Type");
    }

    if (!description) {
      isValid = false;
      missingFields.push("Description");
    }

    if (missingFields.length > 0) {
      setFormError("Please fill in: " + missingFields.join(", "));
    } else {
      setFormError("");
    }

    if (
      type === "Part(s) Exchange" ||
      type === "Part(s) / Consumable Request"
    ) {
      formData.forEach((part, index) => {
        if (!part.partNo) {
          isValid = false;
          newErrors.partNo[index] = "Part No. is required";
        }
        if (!part.qty) {
          isValid = false;
          newErrors.qty[index] = "Qty is required";
        }
        if (!part.description) {
          isValid = false;
          newErrors.description[index] = "Description is required";
        }
      });
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleAddRow = () => {
    setFormData([...formData, { partNo: "", qty: "", description: "" }]);
    setRowCount(rowCount + 1);
  };

  const handleChange = (index, field, value) => {
    const updatedFormData = [...formData];
    updatedFormData[index][field] = value;
    setFormData(updatedFormData);

    const updatedErrors = { ...errors };
    if (field === "partNo" && value) updatedErrors.partNo[index] = "";
    if (field === "qty" && value > 0) updatedErrors.qty[index] = "";
    if (field === "description" && value) updatedErrors.description[index] = "";
    setErrors(updatedErrors);
  };

  const handleContactsChange = (selectedOptions) => {
    setSelectedContacts(selectedOptions);
  };

  const handleFileInputChange = (e) => {
    setSelectedFile(e.target.files[0] || null);
  };

  const handleSaveNewClick = () => {
    if (validateForm()) {
      setIsLoading(true); // Set loading state to true

      const partsRequested =
        type === "Part(s) Exchange" || type === "Part(s) / Consumable Request"
          ? formData.map((part) => ({
              PartNo: part.partNo,
              PartDescription: part.description,
              Qty: part.qty,
            }))
          : [];

      const formDataToSend = new FormData();
      formDataToSend.append("MachineID", machineID);
      formDataToSend.append("Status", status);
      formDataToSend.append("Description", description);
      formDataToSend.append("Type", type);
      formDataToSend.append("Origin", "Web");
      formDataToSend.append("Contacts", JSON.stringify(selectedContacts.map((contact) => contact.value)));
      formDataToSend.append("ServiceRequestOwner", machinenamedata.find(
        (m) => m.id === selectedMachine
      ).Assigned_Engineer_id);
      formDataToSend.append("PartRequested", JSON.stringify(partsRequested));
      formDataToSend.append("Email", email);
      if (selectedFile) {
        formDataToSend.append("file", selectedFile);
      }

      axios
        .post(
          "/server/jad_group_website_function/create-service-request",
          formDataToSend,
          { headers: { "Content-Type": "multipart/form-data" } }
        )
        .then((response) => {
          console.log("Successfully posted data:", response.data);

          // Show submitted message
          setSubmittedMessage("Your request has been submitted successfully!");

          resetForm();
          setDescription("");

          setTimeout(() => {
            setSubmittedMessage("");
          }, 2000);
        })
        .catch((error) => {
          console.error("Error posting data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const fetchData = useCallback(async () => {
    try {
      const [machineData, contactData, partNoData] = await Promise.all([
        axios.get(
          `/server/jad_group_website_function/sr-creation-machine?Customer_Email=${email}`
        ),
        axios.get(
          `/server/jad_group_website_function/sr-creation-contact?Customer_Email=${email}`
        ),
        axios.get("/server/manufacturer-list/part-number-list-details"),
      ]);

      setMachinenamedata(machineData.data.data);
      setContactnamedata(contactData.data.data);
      if (partNoData.data && Array.isArray(partNoData.data.part_numbers)) {
        setPartNumbersList(partNoData.data.part_numbers);
      }

      const allContacts = contactData.data.data.Contacts.map((contact) => ({
        value: contact.id,
        label: `${contact["Contact Name"]} - ${contact.Email}`,
      }));
      setSelectedContacts(allContacts);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [email]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (selectedMachine) {
      const machine = machinenamedata.find((m) => m.id === selectedMachine);
      if (machine) {
        setSelectedOwner(machine.Assigned_Engineer);
      }
    }
  }, [selectedMachine, machinenamedata]);

  const submit_close = () => {
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    const partsRequested =
      type === "Part(s) Exchange" || type === "Part(s) / Consumable Request"
        ? formData.map((part) => ({
            PartNo: part.partNo,
            PartDescription: part.description,
            Qty: part.qty,
          }))
        : [];

    const formDataToSend = new FormData();
    formDataToSend.append("MachineID", machineID);
    formDataToSend.append("Status", status);
    formDataToSend.append("Description", description);
    formDataToSend.append("Type", type);
    formDataToSend.append("Origin", "Web");
    formDataToSend.append("Contacts", JSON.stringify(selectedContacts.map((contact) => contact.value)));
    formDataToSend.append("ServiceRequestOwner", machinenamedata.find((m) => m.id === selectedMachine)
      .Assigned_Engineer_id);
    formDataToSend.append("PartRequested", JSON.stringify(partsRequested));
    formDataToSend.append("Email", email);
    if (selectedFile) {
      formDataToSend.append("file", selectedFile);
    }

    axios
      .post(
        "/server/jad_group_website_function/create-service-request",
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      )
      .then((response) => {
        console.log("Successfully posted data:", response.data);
        setSubmittedMessage("Your request has been submitted successfully!");
        resetForm();
        setDescription("");
        setTimeout(() => {
          setSubmittedMessage("");
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        console.error("Error posting data:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const resetForm = () => {
    setRowCount(1);
    setSelectedContacts([]);
    setSelectedOwner("");
    setType("");
    setDescription("");
    setMachineID("");
    setStatus("");
    setFormData([{ partNo: "", qty: "", description: "" }]);
    setSelectedMachine(null);
    setSelectedFile(null);
  };

  const customStyles = {
    multiValue: (provided) => ({
      ...provided,
      display: "contents",
      width: "100%",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      display: "block",
      whiteSpace: "normal",
    }),
  };

  const typeOptions = [
    { value: "", label: "-None-" },
    { value: "Part(s) Exchange", label: "Part(s) Exchange" },
    { value: "Part(s) / Consumable Request", label: "Part(s) / Consumable(s) Order" },
    { value: "2nd Level Remote Technical Support", label: "2nd Level Remote Technical Support" },
    { value: "On-Site Service Visit", label: "On-Site Service Visit" },
    { value: "Calibration Service", label: "Calibration Service" },
  ];

  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const [isMachineOpen, setIsMachineOpen] = useState(false);
  const dropdownRef = useRef(null);
  const machineDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsTypeOpen(false);
      }
      if (machineDropdownRef.current && !machineDropdownRef.current.contains(event.target)) {
        setIsMachineOpen(false);
      }
      if (
        openPartDropdownIndex !== null &&
        partDropdownWrapperRefs.current[openPartDropdownIndex] &&
        !partDropdownWrapperRefs.current[openPartDropdownIndex].contains(event.target)
      ) {
        setOpenPartDropdownIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openPartDropdownIndex]);

  const handleTypeSelect = (value) => {
    setType(value);
    setIsTypeOpen(false);
  };

  const handleMachineSelect = (machineId) => {
    setMachineID(machineId);
    setSelectedMachine(machineId);
    setIsMachineOpen(false);
  };

  return (
    <div className={props.isPopupOpen ? "Popup_box" : "d-none"}>
      <div className="Inside_popup">
        <h1>Service Request Information</h1>
        <p>A brief description of the service you are requesting.</p>
        <div className="Section_">
          <div className="First_form">
            <div className="Selection_">
              <label>Machine Name <span className="required-star">*</span></label>
              <div className="custom-dropdown-wrapper" ref={machineDropdownRef}>
                <div
                  className={`custom-dropdown editable-field ${isMachineOpen ? "open" : ""} ${!selectedMachine ? "placeholder" : ""}`}
                  onClick={() => setIsMachineOpen(!isMachineOpen)}
                >
                  <span className="custom-dropdown-text">
                    {selectedMachine
                      ? machinenamedata.find((m) => m.id === selectedMachine)?.["Machine Name"] || "Select machine"
                      : "Select machine"}
                  </span>
                  <span className="custom-dropdown-arrow">{isMachineOpen ? "\u25B2" : "\u25BC"}</span>
                </div>
                {isMachineOpen && (
                  <ul className="custom-dropdown-menu">
                    {machinenamedata.map((machine, index) => (
                      <li
                        key={index}
                        className={`custom-dropdown-item ${selectedMachine === machine.id ? "selected" : ""}`}
                        onClick={() => handleMachineSelect(machine.id)}
                      >
                        {machine["Machine Name"]}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="Selection_">
              <label>Type <span className="required-star">*</span></label>
              <div className="custom-dropdown-wrapper" ref={dropdownRef}>
                <div
                  className={`custom-dropdown editable-field ${isTypeOpen ? "open" : ""} ${!type ? "placeholder" : ""}`}
                  onClick={() => setIsTypeOpen(!isTypeOpen)}
                >
                  <span className="custom-dropdown-text">
                    {type ? typeOptions.find((o) => o.value === type)?.label : "-None-"}
                  </span>
                  <span className="custom-dropdown-arrow">{isTypeOpen ? "\u25B2" : "\u25BC"}</span>
                </div>
                {isTypeOpen && (
                  <ul className="custom-dropdown-menu">
                    {typeOptions.map((option, index) => (
                      <li
                        key={index}
                        className={`custom-dropdown-item ${type === option.value ? "selected" : ""}`}
                        onClick={() => handleTypeSelect(option.value)}
                      >
                        {option.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div
              className="Selection_"
              style={{ display: isVisible ? "none" : "none" }}
            >
              <label>Origin</label>
              <select
                name="Selectorigin"
                id="Selectorigin"
                className="origin-style"
                onChange={(e) => setOrigin(e.target.value)}
                value={origin}
              >
                <option value="">Select origin</option>
                <option value="Web">Web</option>
              </select>
            </div>

            <div style={{ display: "none" }} className="Selection_">
              <label>Contacts</label>
              <div style={{ width: "435px" }}>
                <Select
                  isMulti
                  value={selectedContacts}
                  onChange={handleContactsChange}
                  options={
                    Servicerequestformdata.Contacts &&
                    Servicerequestformdata.Contacts.map((contact) => ({
                      value: contact.id,
                      label: `${contact["Contact Name"]} - ${contact.Email}`,
                    }))
                  }
                  styles={customStyles}
                />
              </div>
            </div>

            <div className="Selection_">
              <label>Description <span className="required-star">*</span></label>
              <input
                className="placeholder-description editable-field"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="  Description"
              />
            </div>
          </div>

          <div className="First_form">
            {!props.hideOwner && (
              <div className="Selection_">
                <label>Service Request Owner</label>
                <div className="readonly-field-wrapper">
                  <input
                    type="text"
                    value={selectedOwner}
                    readOnly
                    className="readonly-field"
                  />
                  <span className="readonly-badge">Auto-assigned</span>
                </div>
              </div>
            )}

            <div style={{ marginTop: props.hideOwner ? "0px" : "15px" }} className="Selection_">
              <label>Diagnostic/Other Files</label>
              <input
                type="file"
                id="myfile"
                name="myfile"
                className="editable-field"
                onChange={handleFileInputChange}
              />
            </div>
          </div>
        </div>

        {(type === "Part(s) Exchange" ||
          type === "Part(s) / Consumable Request") && (
          <div style={{ paddingBottom: "60px" }}>
            <h1 style={{ margin: "20px 0 10px 0" }}>Part Requested</h1>
            {[...Array(rowCount)].map((_, index) => (
              <div key={index} className="First_forms" style={{ position: "relative", zIndex: openPartDropdownIndex === index ? 99999 : 1 }}>
                <div className="Selection_s">
                  <label>Part No.</label>
                  <div
                    className="custom-dropdown-wrapper"
                    style={{ zIndex: openPartDropdownIndex === index ? 99999 : 1 }}
                    ref={(el) => (partDropdownWrapperRefs.current[index] = el)}
                  >
                    <input
                      type="text"
                      placeholder="Enter Part Number"
                      value={formData[index].partNo}
                      onFocus={() => setOpenPartDropdownIndex(index)}
                      onChange={(e) => {
                        handleChange(index, "partNo", e.target.value);
                        setOpenPartDropdownIndex(index);
                      }}
                      className={errors.partNo[index] ? "error editable-field" : "editable-field"}
                    />
                    {openPartDropdownIndex === index && (
                      <ul className="custom-dropdown-menu">
                        {partNumbersList
                          .filter((pNo) =>
                            pNo.toLowerCase().includes((formData[index].partNo || "").toLowerCase())
                          )
                          .slice(0, 100)
                          .map((pNo, pIdx) => (
                            <li
                              key={pIdx}
                              className={`custom-dropdown-item ${formData[index].partNo === pNo ? "selected" : ""}`}
                              onMouseDown={() => {
                                handleChange(index, "partNo", pNo);
                                setOpenPartDropdownIndex(null);
                              }}
                            >
                              {pNo}
                            </li>
                          ))}
                        {partNumbersList.filter((pNo) =>
                          pNo.toLowerCase().includes((formData[index].partNo || "").toLowerCase())
                        ).length === 0 && (
                          <li
                            className="custom-dropdown-item"
                            style={{ color: "#999", cursor: "default" }}
                          >
                            No matching part number found
                          </li>
                        )}
                      </ul>
                    )}
                  </div>
                  {errors.partNo[index] && (
                    <span className="error-message">
                      {errors.partNo[index]}
                    </span>
                  )}
                </div>
                <div className="Selection_s">
                  <label>Qty</label>
                  <input
                    type="number"
                    placeholder="Enter Qty in Numbers"
                    value={formData[index].qty}
                    onChange={(e) => handleChange(index, "qty", e.target.value)}
                    className={errors.qty[index] ? "error" : ""}
                  />
                  {errors.qty[index] && (
                    <span className="error-message">{errors.qty[index]}</span>
                  )}
                </div>
                <div className="Selection_s">
                  <label>Description</label>
                  <input
                    type="text"
                    placeholder="Enter Text Description"
                    value={formData[index].description}
                    onChange={(e) =>
                      handleChange(index, "description", e.target.value)
                    }
                    className={errors.description[index] ? "error" : ""}
                  />
                  {errors.description[index] && (
                    <span className="error-message">
                      {errors.description[index]}
                    </span>
                  )}
                </div>
              </div>
            ))}
            <button className="Create-Service-Request" onClick={handleAddRow}>
              + Add Row
            </button>
          </div>
        )}

        {formError && (
          <p style={{ color: "red", fontWeight: "bold", margin: "10px 20px", fontSize: "14px" }}>
            {formError}
          </p>
        )}
        {showButtons && (
          <div className="Submit_button_box">
            <button className="Cancel" onClick={props.onClose}>
              Cancel
            </button>
            <button className="Save_New" onClick={handleSaveNewClick}>
              Save and New
            </button>
            <button className="Save" onClick={submit_close}>
              Save
            </button>
          </div>
        )}
        {isLoading ? (
          <div className="popup-overlay">
            <div className="loading-message">Processing...</div>
          </div>
        ) : (
          submittedMessage && (
            <div className="popup-overlay">
              <div className="submitted-message">{submittedMessage}</div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default PopupComponent;
